/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  IconButton,
  TablePagination,
  Chip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { environment } from '../../environments/environment';
import AddButton from 'datascient-ui-library/src/lib/Molecules/AddButton/AddButton';
import { dsVar, ink } from '../theme/tokens';

const cardIcons = [
  { icon: <EditIcon />, color: '#159DFF', bgColor: 'rgba(21, 157, 255, 0.15)' },
  // ... other icons will be added here
];

const AgentMarketplace = () => {
  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const navigate = useNavigate();

  const getFlowTemplateForOrg = async () => {
    try {
      const data = {
        data: {
          activity_class: ['AGENT'],
        },
      };
      const res = await axios.post(
        `${environment.apiUrl}/agent/getFlowTemplateForOrg`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setTableData(res?.data || []);
      setFilteredData(res?.data || []);
    } catch (error) {
      console.log('error', error);
      if (
        error?.response?.data?.error === 'jwt malformed' ||
        error?.response?.data?.error === 'jwt expired'
      ) {
        navigate('/login');
      }
    }
  };

  useEffect(() => {
    getFlowTemplateForOrg();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    const filtered = tableData.filter((item) =>
      item.flow_template_name
        .toLowerCase()
        .includes(event.target.value.toLowerCase())
    );
    setFilteredData(filtered);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRowClick = (row) => {
    navigate('/AIStudio/customize', { state: { flow_template_code: row.flow_template_code, operator_name: row.flow_template_name, returnTo: { pathname: '/AIStudio' } } });
  };

  return (
    <Box sx={{
      backgroundColor: dsVar('page'),
      borderRadius: '12px',
      padding: '24px',
      margin: '0',
      minHeight: '100%'
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '32px',
        padding: '0 24px'
      }}>
        <Box sx={{
          color: dsVar('accent-fg'),
          fontWeight: '600',
          fontSize: '32px',
          fontFamily: 'Inter, sans-serif'
        }}>
          Agent Marketplace
        </Box>

        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px'
        }}>
          <TextField
            placeholder="Search for an Agent"
            value={searchTerm}
            onChange={handleSearchChange}
            variant="outlined"
            size="small"
            sx={{
              width: '300px',
              '& .MuiOutlinedInput-root': {
                backgroundColor: dsVar('surface'),
                color: dsVar('fg-body'),
                borderRadius: '8px',
                '& fieldset': { borderColor: dsVar('line') },
                '&:hover fieldset': {
                  borderColor: dsVar('accent-fg'),
                },
                '&.Mui-focused fieldset': {
                  borderColor: dsVar('accent-fg'),
                }
              }
            }}
            InputProps={{
              endAdornment: (
                <IconButton>
                  <SearchIcon sx={{ color: dsVar('fg-2') }} />
                </IconButton>
              ),
            }}
          />

          <AddButton
            text={'Add'}
            icon={<Add />}
            sx={{ fontSize: '16px', marginLeft: '30px', color: dsVar('accent-fg'), marginRight: '30px', border: `1px solid ${dsVar('accent-fg')}`, borderRadius: '8px' }}
            handleClick={() => {
              navigate('/AIStudio/customize', { state: { returnTo: { pathname: '/AIStudio' } } });
            }}
          />
        </Box>
      </Box>

      <Grid container spacing={3}>
        {filteredData
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  onClick={() => handleRowClick(row)}
                  sx={{
                    cursor: 'pointer',
                    height: '100%',
                    backgroundColor: dsVar('surface'),
                    border: `1px solid ${dsVar('line')}`,
                    borderRadius: '12px',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'translateY(-2px)',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.3)',
                      borderColor: dsVar('accent-fg')
                    }
                  }}
                >
                  <CardContent sx={{ padding: '20px' }}>
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '12px'
                    }}>
                      <Box sx={{
                        backgroundColor: 'rgba(21, 157, 255, 0.15)',
                        borderRadius: '8px',
                        padding: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <EditIcon sx={{ color: ink('#159DFF') }} />
                      </Box>

                      <Box sx={{ flex: 1 }}>
                        <Typography sx={{
                          fontWeight: 600,
                          color: dsVar('fg-body'),
                          marginBottom: '8px',
                          fontSize: '16px',
                          lineHeight: '1.4'
                        }}>
                          {row.flow_template_name}
                        </Typography>

                        <Typography sx={{
                          color: dsVar('fg-2'),
                          fontSize: '14px',
                          lineHeight: '1.5',
                          marginBottom: '16px'
                        }}>
                          {row.flow_template_description}
                        </Typography>

                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}>
                          <Chip
                            label={row.flow_type_name}
                            size="small"
                            sx={{
                              backgroundColor: 'rgba(21, 157, 255, 0.15)',
                              color: ink('#159DFF'),
                              fontWeight: 500,
                              fontSize: '12px'
                            }}
                          />

                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRowClick(row);
                            }}
                            sx={{
                              color: dsVar('fg-muted'),
                              '&:hover': {
                                backgroundColor: 'rgba(255, 222, 89, 0.08)',
                                color: dsVar('accent-fg')
                              }
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
      </Grid>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '32px',
        borderTop: `1px solid ${dsVar('line')}`,
        paddingTop: '16px'
      }}>
        <TablePagination
          component="div"
          count={filteredData.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[9, 18, 27]}
          sx={{
            color: dsVar('fg-body'),
            '& .MuiTablePagination-toolbar': {
              color: dsVar('fg-body'),
            },
            '& .MuiTablePagination-selectLabel': {
              color: dsVar('fg-2'),
            },
            '& .MuiTablePagination-displayedRows': {
              color: dsVar('fg-2'),
            },
            '& .MuiTablePagination-select': {
              color: dsVar('fg-body'),
            },
            '& .MuiTablePagination-actions button': {
              color: dsVar('fg-2'),
              '&:not(:disabled)': {
                color: dsVar('fg-body'),
              },
              '&:hover': {
                backgroundColor: 'rgba(255, 222, 89, 0.1)',
                color: dsVar('accent-fg'),
              },
            },
            '& .MuiSelect-icon': {
              color: dsVar('fg-2'),
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default AgentMarketplace;
